import BaseModel from '../core/BaseModel';

export default class VoucherVehicleCategoryModel extends BaseModel {

    constructor() {
        super({
                name: "voucher_vehicle_category",
                tableName: 'voucher_vehicle_category',
                label: "Voucher Vehicle Category",
                display_key: 'voucher_id'  // Hiển thị voucher_id trong bảng
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                voucher_id: {
                    name: 'voucher_id',
                    type: "Uuid",
                    label: 'Voucher ID',
                    width: 20,
                    class: 'left',
                    filter: { type: 'input', match: 'contains' }
                },
                vehicle_category_id: {
                    name: 'vehicle_category_id',
                    type: "Uuid",
                    label: 'Vehicle Category ID',
                    width: 20,
                    class: 'left',
                    filter: { type: 'input', match: 'contains' }
                },
                created_at: {
                    name: 'created_at',
                    type: "Datetime",
                    label: 'Created At',
                    width: 10,
                    class: 'center',
                    filter: { type: 'DateRange', match: 'equals' }
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Updated At',
                    width: 10,
                    class: 'center',
                    filter: { type: 'DateRange', match: 'equals' }
                },
                updated_by: {
                    name: 'updated_by',
                    type: "Uuid",
                    label: 'Updated By',
                    display: false
                },
                created_by: {
                    name: 'created_by',
                    type: "Uuid",
                    label: 'Created By',
                    display: false
                },
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        { value: 'true', label: 'Yes', style: 'color:  #000000;' },
                        { value: 'false', label: 'No', style: 'color:  #000000;' }
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: "center",
                    width: 8,
                },
                deleted: {
                    name: "deleted",
                    type: "Boolean",
                    label: "Deleted",
                    display: false
                }
            })
    }
}
